import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import "rxjs";
import { BehaviorSubject, Observable } from "rxjs";

import { HttpService } from "./http.service";
import { CommonService } from "./common-service.service";
import { catchError } from "rxjs/operators";
import { environment } from "src/environments/environment";
@Injectable()
export class DataStorageService {
  newbaseURL: string = environment.apiEndpoint;
  private access_token = localStorage.getItem("access_token");
  constructor(
    private http: HttpClient,
    private commonService: CommonService,
    private httpService: HttpService
  ) { }


  getData(servicePath: string): Observable<any> {
    let headers = this.commonService.getHeaders();
    const httpOptions = { headers: headers };
    return this.http
      .get<any>(this.newbaseURL + servicePath, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getSoSData(servicePath: string): Observable<any> {
    let headers = this.commonService.getHeaders();
    const httpOptions = { headers: headers };
    return this.http
      .get<any>(servicePath, httpOptions)
      .pipe(catchError(this.handleError));
  }
  postSoSData(servicePath: string) {
    let headers = this.commonService.getHeaders();
    const httpOptions = { headers: headers };
    return this.http
      .post(servicePath, {}, httpOptions)
      .pipe(catchError(this.handleError));
  }

  postData(servicePath: string, data: any) {
    let headers = this.commonService.getHeaders();
    const httpOptions = { headers: headers };
    return this.http
      .post(this.newbaseURL + servicePath, data, httpOptions)
      .pipe(catchError(this.handleError));
  }


  private handleError(error: HttpErrorResponse) {
    console.log(error);
    return Observable.throw(error.message || "Server Error");
  }

  userValidate(obj: any) {
    return this.httpService.postData(
      environment.apiEndpoint + "/Account/Authenticate",
      obj,
      ""
    );
  }

  SMSAPIData(URLData: any) {
    return this.httpService.postData(URLData, "", "");
  }

  /**
   * New Version Methods
   */
  saveAPIData(obj: any, sp_name: string) {
    return this.httpService.postData(
      environment.apiEndpoint + "/" + sp_name,
      obj,
      this.access_token
    );
  }
  getMasterData(obj: any, sp_name: string) {
    return this.httpService.postData(
      environment.apiEndpoint + "/master/" + sp_name,
      obj,
      this.access_token
    );
  }

  getAPIData(obj: any, sp_name: string) {
    return this.httpService.postData(
      environment.apiEndpoint + "/" + sp_name,
      obj,
      this.access_token
    );
  }
  getNewMasterData(obj: any, sp_name: string) {
    return this.httpService.postData(
      environment.apiEndpoint + "/Company/" + sp_name,
      obj,
      this.access_token
    );
  }

  saveNewMasterData(obj: any, sp_name: string) {
    return this.httpService.postData(
      environment.apiEndpoint + "/Company/" + sp_name,
      obj,
      this.access_token
    );
  }

  /**
   *
   */
}
